import React from 'react';
import type { SVGProps } from 'react';
const SvgTiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 19"
    {...props}
  >
    <g fill={props?.fill || 'rgb(172, 185, 201)'} clipPath="url(#tiktok_svg__a)">
      <path d="M14.99 3.413A4.2 4.2 0 0 1 13.95.635h-.815c.21 1.161.9 2.157 1.854 2.778M7.454 9.416a2.56 2.56 0 0 0-2.558 2.56c0 .983.56 1.84 1.374 2.267a2.53 2.53 0 0 1-.485-1.494 2.56 2.56 0 0 1 2.558-2.56c.263 0 .518.046.756.12V7.197a6 6 0 0 0-.756-.053c-.046 0-.087.004-.132.004v2.387a2.6 2.6 0 0 0-.757-.12" />
      <path d="M17.293 4.781v2.367a7.24 7.24 0 0 1-4.236-1.362v6.194a5.614 5.614 0 0 1-5.605 5.61 5.6 5.6 0 0 1-3.212-1.017 5.6 5.6 0 0 0 4.1 1.79 5.614 5.614 0 0 0 5.606-5.61V6.56a7.24 7.24 0 0 0 4.236 1.363V4.876q-.463-.001-.889-.095" />
      <path d="M13.059 11.979V5.784a7.24 7.24 0 0 0 4.235 1.363V4.78a4.23 4.23 0 0 1-2.306-1.367 4.26 4.26 0 0 1-1.86-2.778H10.9l-.005 12.212a2.56 2.56 0 0 1-2.553 2.466 2.57 2.57 0 0 1-2.077-1.066 2.57 2.57 0 0 1-1.374-2.268 2.56 2.56 0 0 1 2.558-2.56c.263 0 .518.045.757.119V7.151c-3.027.066-5.47 2.552-5.47 5.602 0 1.473.572 2.815 1.505 3.82a5.6 5.6 0 0 0 3.212 1.016c3.089 0 5.606-2.52 5.606-5.61" />
    </g>
    <defs>
      <clipPath id="tiktok_svg__a">
        <path fill={props?.fill || 'rgb(172, 185, 201)'} d="M.076.5H21.35v18H.076z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTiktok;
